<template>
  <el-container class="pr bg-theme task-manage">
    <div class="content bg-f w-100">
      <cus-table
        :tableParams="tableParams"
        :tableData="tableData"
        :colData="colData"
        :tableHeightData="tableHeightData"
      >
        <template v-slot:colslot="{ scope, prop }">
          <div v-if="prop == 'jobName'">
            {{ scope.row.jobInstance.jobName }}
          </div>
          <div v-else-if="prop == 'jobParameters'">
            <p
              v-for="(item, name, index) in scope.row.jobParameters.parameters"
              :key="name + index"
            >
              {{ name }}:{{ item.value }}
            </p>
          </div>
          <div v-else-if="prop == 'status'" class="dp-flex align-item-c">
            <span
              style="color: #409eff"
              :style="{ color: scope.row.status == 'FAILED' ? 'red' : '' }"
              >{{ scope.row.status }}</span
            >
          </div>
          <div v-else-if="prop == 'excuteInfo'">
            <span
              class="cursor-pointer"
              @click="queryInfo(scope.row)"
              style="color: #409eff"
              >查看详情</span
            >
          </div>
        </template>
      </cus-table>
    </div>
    <!-- 刷新 -->
    <el-tooltip content="点击刷新">
      <el-button
        style="left: 90px; top: -62px"
        class="pa"
        type="text"
        icon="el-icon-refresh"
        @click="refreshTaskList"
      ></el-button>
    </el-tooltip>
    <!-- 任务详情 -->
    <task-detail
      v-if="hasDetail"
      :visible="detailDialogVisible"
      title="当前行的所有信息"
      width="50%"
      :currentRow="currentRow"
      @close-dialog="detailDialogVisible = false"
    ></task-detail>
  </el-container>
</template>

<script>
import { sessionJobs } from "@/api/taskManage";
import cusTable from "@/views/components/cusTable";
import taskDetail from "@/views/taskManage/components/taskDetail";
export default {
  components: {
    cusTable,
    taskDetail,
  },
  data() {
    return {
      hasDetail: false,
      currentRow: {},
      detailDialogVisible: false,
      tableParams: { className: "cus-table", isTableHeight: true },
      // 设置高度需要的数据
      tableHeightData: [
        { selector: ".navbar", cssProperty: "height" },
        { selector: ".app-main", cssProperty: "paddingTop" },
        { selector: ".app-main", cssProperty: "paddingBottom" },
        { selector: ".auth-wrap", cssProperty: "paddingTop" },
        { selector: ".auth-wrap", cssProperty: "paddingBottom" },
        { selector: ".cus-header", cssProperty: "height" },
        { selector: ".cus-header", cssProperty: "marginBottom" },
      ],
      tableData: [],
      tableData2: [
        {
          jobParameters: {
            parameters: {
              loadAccountFromDb: {
                identifying: true,
                value: 1,
                type: "LONG",
              },
              level: {
                identifying: true,
                value: "ad",
                type: "STRING",
              },
              time_increment: {
                identifying: true,
                value: "1",
                type: "STRING",
              },
              date_end: {
                identifying: true,
                value: "2021-04-01",
                type: "STRING",
              },
              date_start: {
                identifying: true,
                value: "2021-04-01",
                type: "STRING",
              },
              thirdLoginIds: {
                identifying: true,
                value: "1781076392060323",
                type: "STRING",
              },
              onlyAccountIds: {
                identifying: true,
                value: "23846331893000044",
                type: "STRING",
              },
            },
            empty: false,
          },
          jobInstance: {
            id: 0,
            version: 0,
            jobName: "fbAdIncEntityReportJob",
            instanceId: 0,
          },
          stepExecutions: [
            {
              stepName: "loadCredentialStep",
              status: "FAILED",
              readCount: 0,
              writeCount: 0,
              commitCount: 0,
              rollbackCount: 1,
              readSkipCount: 0,
              processSkipCount: 0,
              writeSkipCount: 0,
              startTime: 1617261495291,
              endTime: 1617261496185,
              lastUpdated: 1617261496185,
              exitStatus: {
                exitCode: "FAILED",
                exitDescription:
                  "java.lang.Exception: 凭据ids=Credential{id='1781076392060323', thirdUserEmail='fbmbj9632@126.com'},个号中没有：23846331893000044\r\n\tat com.giikin.ads.fb.campaign.local.job.support.core.AdCredentailLoadTasklet.testLoseAccountId(AdCredentailLoadTasklet.java:109)\r\n\tat com.giikin.ads.fb.campaign.local.job.support.core.AdCredentailLoadTasklet.execute(AdCredentailLoadTasklet.java:86)\r\n\tat java.base/jdk.internal.reflect.NativeMethodAccessorImpl.invoke0(Native Method)\r\n\tat java.base/jdk.internal.reflect.NativeMethodAccessorImpl.invoke(NativeMethodAccessorImpl.java:62)\r\n\tat java.base/jdk.internal.reflect.DelegatingMethodAccessorImpl.invoke(DelegatingMethodAccessorImpl.java:43)\r\n\tat java.base/java.lang.reflect.Method.invoke(Method.java:566)\r\n\tat org.springframework.aop.support.AopUtils.invokeJoinpointUsingReflection(AopUtils.java:344)\r\n\tat org.springframework.aop.framework.ReflectiveMethodInvocation.invokeJoinpoint(ReflectiveMethodInvocation.java:198)\r\n\tat org.springframework.aop.framework.ReflectiveMethodInvocation.proceed(ReflectiveMethodInvocation.java:163)\r\n\tat org.springframework.aop.support.DelegatingIntroductionInterceptor.doProceed(DelegatingIntroductionInterceptor.java:136)\r\n\tat org.springframework.aop.support.DelegatingIntroductionInterceptor.invoke(DelegatingIntroductionInterceptor.java:124)\r\n\tat org.springframework.aop.framework.ReflectiveMethodInvocation.proceed(ReflectiveMethodInvocation.java:186)\r\n\tat org.springframework.aop.framework.JdkDynamicAopProxy.invoke(JdkDynamicAopProxy.java:212)\r\n\tat com.sun.proxy.$Proxy427.execute(Unknown Source)\r\n\tat org.springframework.batch.core.step.tasklet.TaskletStep$ChunkTransactionCallback.doInTransaction(TaskletStep.java:407)\r\n\tat org.springframework.batch.core.step.tasklet.TaskletStep$ChunkTransactionCallback.doInTransaction(TaskletStep.java:331)\r\n\tat org.springframework.transaction.support.TransactionTemplate.execute(TransactionTemplate.java:140)\r\n\tat org.springframework.batch.core.step.tasklet.TaskletStep$2.doInChunkContext(TaskletStep.java:273)\r\n\tat org.springframework.batch.core.scope.context.StepContextRepeatCallback.doInIteration(StepContextRepeatCallback.java:82)\r\n\tat org.springframework.batch.repeat.support.RepeatTemplate.getNextResult(RepeatTemplate.java:375)\r\n\tat org.springframework.batch.repeat.support.RepeatTemplate.executeInternal(RepeatTemplate.java:215)\r\n\tat org.springframework.batch.repeat.support.RepeatTemplate.iterate(RepeatTemplate.java:145)\r\n\tat org.springframework.batch.core.step.tasklet.TaskletStep.doExecute(TaskletStep.java:258)\r\n\tat org.springframework.batch.core.step.AbstractStep.execute(AbstractStep.java:208)\r\n\tat org.springframework.batch.core.job.SimpleStepHandler.handleStep(SimpleStepHandler.java:148)\r\n\tat org.springframework.batch.core.job.flow.JobFlowExecutor.executeStep(JobFlowExecutor.java:68)\r\n\tat org.springframework.batch.core.job.flow.support.state.StepState.handle(StepState.java:68)\r\n\tat org.springframework.batch.core.job.flow.support.SimpleFlow.resume(SimpleFlow.java:169)\r\n\tat org.springframework.batch.core.job.flow.support.SimpleFlow.start(SimpleFlow.java:144)\r\n\tat org.springframework.batch.core.job.flow.support.state.FlowState.handle(FlowState.java:56)\r\n\tat org.springframework.batch.core.job.flow.support.SimpleFlow.resume(SimpleFlow.java:169)\r\n\tat org.springframework.batch.core.job.flow.support.SimpleFlow.start(SimpleFlow.java:144)\r\n\tat org.springframework.batch.core.job.flow.FlowJob.doExecute(FlowJob.java:137)\r\n\tat org.springframework.batch.core.job.AbstractJob.execute(AbstractJob.java:319)\r\n\tat org.springframework.batch.core.launch.support.SimpleJobLauncher$1.run(SimpleJobLauncher.java:147)\r\n\tat java.base/java.util.concurrent.ThreadPoolExecutor.runWorker(ThreadPoolExecutor.java:1128)\r\n\tat java.base/java.util.concurrent.ThreadPoolExecutor$Worker.run(ThreadPoolExecutor.java:628)\r\n\tat java.base/java.lang.Thread.run(Thread.java:834)\r\n",
                running: false,
              },
              filterCount: 0,
            },
          ],
          status: "FAILED",
          startTime: 1617261495285,
          createTime: 1617261495256,
          endTime: 1617261496187,
          lastUpdated: 1617261496187,
          exitStatus: {
            exitCode: "FAILED",
            exitDescription: "",
            running: false,
          },
          jobId: 0,
        },
      ],
      colData: [
        { label: "任务名称", prop: "jobName", width: "200" },
        { label: "任务参数", prop: "jobParameters" },
        { label: "执行状态", prop: "status", width: "120" },
        { label: "执行情况", prop: "excuteInfo", width: "120" },
        { label: "最后更新时间", prop: "lastUpdated" },
      ],
    };
  },
  methods: {
    refreshTaskList() {
      this.sessionJobs();
    },
    sessionJobs() {
      this.$showLoading();
      sessionJobs().then((res) => {
        this.$hideLoading();
        if (res.code == 0) {
          // this.tableData = res.data ? res.data : this.tableData2;
          this.tableData = res.data ? res.data : [];
        }
      });
    },
    queryInfo(row) {
      this.currentRow = row;
      this.hasDetail = true;
      this.detailDialogVisible = true;
    },
  },
  created() {
    this.sessionJobs();
  },
};
</script>
<style lang="scss">
@import "@/styles/commonly";
.task-manage {
  padding: 8px;
  .content {
    padding: 16px 32px 0;
  }
  .cus-header {
    padding: 16px 0;
    margin-bottom: 8px;
  }
  .cus-table.el-table {
    color: rgba(0, 0, 0, 0.85);
    th {
      background: #fafafa !important;
    }
    thead {
      tr th {
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .cell {
      padding: {
        left: 16px;
        right: 16px;
      }
    }
    th,
    td {
      padding: {
        top: 16px;
        bottom: 16px;
      }
    }
    .el-table__row:nth-child(2n-1) {
      background: #f8f8fa;
    }
    i {
      margin-right: 0;
    }
    .el-table__body-wrapper {
      height: auto !important;
    }
  }
}
.static-btn {
  color: #3b87e5;
  border: 1px solid #c8e0ff;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  cursor: pointer;
  word-break: keep-all;
}
.small-circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
</style>
